module.exports = __webpack_public_path__ + "img/map.05e3ab33.svg";